import React from 'react';
import { withFormik } from 'formik';
import { connect } from 'react-redux';

import User from '+/models/User';
import { patchUser } from '+/utils/apiCalls';
import { notifyError, notifySuccess } from '+/utils/toastsManager';
import * as actions from '+/actions';
import { subscribe } from '+/utils/pushSubscriber';
import useCurrentUser from '+/utils/hooks/useCurrentUser';
import useAllActionTypeTemplates from '+/utils/hooks/useAllActionTypeTemplates';
import TextReader from '+/utils/TextReader';
import useAllActionTypeMappings from '+/utils/hooks/useActionTypeMappings';

import validators from './PreferencesForm.validators';
import { PreferencesForm } from './PreferencesForm.component';

const { t } = new TextReader('preferences');

const transformCheckboxValuesToCustomArray = data => {
  const customActionTypes = [];

  Object.keys(data).forEach(key => {
    const [customLabel, actionTypeTemplateId] = key.split('#');
    if (customLabel === 'customActionTypesEnabled' && actionTypeTemplateId) {
      if (data[key]) {
        customActionTypes.push(parseInt(actionTypeTemplateId, 10));
      }
      // eslint-disable-next-line no-param-reassign
      delete data[key];
    }
  });
  return { ...data, customActionTypesEnabled: customActionTypes };
};

const transformCustomArrayToCheckboxValues = data => {
  if (!data.customActionTypesEnabled) return {};
  return data.customActionTypesEnabled.reduce((accum, aTId) => ({ ...accum, [`customActionTypesEnabled#${aTId}`]: true }), {});
};

const submitUser = async (userData, { resetForm, props }) => {
  const userId = userData.id;
  const transformedData = transformCheckboxValuesToCustomArray(userData);
  const result = await patchUser(userId, transformedData);
  if (result.errors) notifyError(result);
  else {
    props.updateUser(result);
    notifySuccess(t('updatedSuccess'));
    const newUser = new User(result);
    resetForm(newUser);
    if (newUser.needsBrowserNotificationSubscription()) {
      subscribe();
    }
  }
};

const WrappedPreferencesForm = withFormik({
  mapPropsToValues: props => ({
    ...props.currentUser.actionSettings(),
    emailClient: props.currentUser.emailClient,
    id: props.currentUser.id,
    ...transformCustomArrayToCheckboxValues(props.currentUser.actionSettings()),
    newActionEmailNotificationsEnabled: props.currentUser.newActionEmailNotificationsEnabled,
    newActionBrowserNotificationsEnabled: props.currentUser.newActionBrowserNotificationsEnabled,
  }),
  validationSchema: validators,
  handleSubmit: submitUser,
})(PreferencesForm);

const mapDispatchToProps = dispatch => ({
  updateUser: result => dispatch(actions.updateUser(result)),
});

export default connect(
  null,
  mapDispatchToProps,
)(props => {
  const currentUser = useCurrentUser();
  const allActionTypeTemplates = useAllActionTypeTemplates(true);
  const allActionTypeMappings = useAllActionTypeMappings(true);

  return (
    <WrappedPreferencesForm
      {...props}
      currentUser={currentUser}
      allActionTypeTemplates={allActionTypeTemplates}
      allActionTypeMappings={allActionTypeMappings}
    />
  );
});
